import {
  mdiAccessPointNetwork,
  mdiAccountBox,
  mdiBell,
  mdiCheck,
  mdiCheckBold,
  mdiChevronDown,
  mdiChevronUp,
  mdiClose,
  mdiCloseCircleOutline,
  mdiCloseThick,
  mdiCloudSync,
  mdiContentCopy,
  mdiDownload,
  mdiExclamationThick,
  mdiFaceAgent,
  mdiFileDocument,
  mdiFileDownload,
  mdiGift,
  mdiHammerWrench,
  mdiMinus,
  mdiRefresh,
  mdiRouterWireless,
  mdiSeal,
  mdiThermometerLines,
  mdiTimerSand,
  mdiWeatherWindy,
  mdiWifi,
  mdiWifiSync,
} from '@mdi/js'
import AccessTime from '@mui/icons-material/AccessTime'
import Add from '@mui/icons-material/Add'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import AttachFile from '@mui/icons-material/AttachFile'
import AvTimer from '@mui/icons-material/AvTimer'
import MuiCheck from '@mui/icons-material/Check'
import MuiChevronLeft from '@mui/icons-material/ChevronLeft'
import MuiChevronRight from '@mui/icons-material/ChevronRight'
import Close from '@mui/icons-material/Close'
import Colorize from '@mui/icons-material/Colorize'
import Create from '@mui/icons-material/Create'
import CreateOutlined from '@mui/icons-material/CreateOutlined'
import Delete from '@mui/icons-material/Delete'
import DeleteForeverOutlined from '@mui/icons-material/DeleteForeverOutlined'
import Done from '@mui/icons-material/Done'
import DraftsOutlined from '@mui/icons-material/DraftsOutlined'
import FavoriteBorder from '@mui/icons-material/FavoriteBorder'
import HelpOutlined from '@mui/icons-material/HelpOutlined'
import MuiHistory from '@mui/icons-material/History'
import MuiInfo from '@mui/icons-material/Info'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import Label from '@mui/icons-material/Label'
import LabelOutlined from '@mui/icons-material/LabelOutlined'
import Language from '@mui/icons-material/Language'
import Memory from '@mui/icons-material/Memory'
import Menu from '@mui/icons-material/Menu'
import MoreVert from '@mui/icons-material/MoreVert'
import North from '@mui/icons-material/North'
import Opacity from '@mui/icons-material/Opacity'
import PortableWifiOff from '@mui/icons-material/PortableWifiOff'
import PriorityHigh from '@mui/icons-material/PriorityHigh'
import PriorityHighRounded from '@mui/icons-material/PriorityHighRounded'
import RoomOutlined from '@mui/icons-material/RoomOutlined'
import SignalWifi2Bar from '@mui/icons-material/SignalWifi2Bar'
import South from '@mui/icons-material/South'
import MuiStar from '@mui/icons-material/Star'
import StarBorder from '@mui/icons-material/StarBorder'
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined'
import WifiTethering from '@mui/icons-material/WifiTethering'
import {
  Activity,
  Apple,
  ArrowUpDown,
  Ban,
  BatteryFull,
  Beef,
  BookText,
  BotMessageSquare,
  BrainCircuit,
  BriefcaseMedical,
  Calendar,
  Camera,
  ChartSpline,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleOff,
  CircleQuestionMark,
  Clock,
  ClockAlert,
  CloudCheck,
  CloudUpload,
  Copy,
  Crop,
  Database,
  Download,
  Droplets,
  Edit,
  EllipsisVertical,
  EyeOff,
  FileDown,
  FileText,
  GripVertical,
  Hash,
  History,
  Info,
  KeyRound,
  LayoutGrid,
  Lightbulb,
  Link,
  Link2,
  Link2Off,
  List,
  Map,
  MapPin,
  MapPinned,
  Maximize2,
  Mic,
  Milk,
  MilkOff,
  Minimize2,
  PanelLeftClose,
  PanelLeftOpen,
  Pause,
  PencilLine,
  Pill,
  PillBottle,
  Play,
  PlusIcon,
  RefreshCcw,
  Replace,
  Router,
  Rows3Icon,
  Send,
  Settings,
  ShieldUser,
  Square,
  SquareActivity,
  SquarePen,
  Star,
  StarIcon,
  Tag,
  TestTubeDiagonalIcon,
  Thermometer,
  Tractor,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Undo2Icon,
  UserLock,
  Wheat,
  X,
} from 'lucide-react'

import { MdiIcon } from '#/components/Icon/MdiIcon'

import {
  AbortionIcon,
  AccountIcon,
  AnimalIcon,
  AsteriskIcon,
  AttachIcon,
  AttentionIcon,
  BatchIcon,
  BatteryColoredIcon,
  BirthIcon,
  BullIcon,
  CalendarColoredIcon,
  CallIcon,
  CanSortIcon,
  CComPrimaryIcon,
  CComSecondaryIcon,
  CheckIcon,
  ComfortIcon,
  ConcentrateIcon,
  ConceptionIcon,
  ConnectedIcon,
  CornIcon,
  CowBabyIcon,
  CowComfortColoredIcon,
  CowComfortIcon,
  CSIcon,
  CTechIcon,
  CustomerServiceColoredIcon,
  DataAnalyticsIcon,
  DessertIcon,
  DietIcon,
  DiscardIcon,
  DisconnectedIcon,
  DoubleCheckIcon,
  DrawIcon,
  DryingIcon,
  DtrIcon,
  EmailIcon,
  EmbryoDonorIcon,
  EmbryoTransferIcon,
  ErrorIcon,
  ExclamationBoardIcon,
  ExportIcon,
  FarmDatabaseIcon,
  FarmIcon,
  FinanceColoredIcon,
  FinanceIcon,
  GestationalIcon,
  HandlingIcon,
  HardwareIcon,
  HealthIcon,
  HealthProtocolIcon,
  HeartPulseIcon,
  HeatMonitoringIcon,
  HeatStrengthIcon,
  HelpIcon,
  HomeIcon,
  HumidityColoredIcon,
  ImportIcon,
  InaptIcon,
  IndicatorsIcon,
  InducedLactationIcon,
  InfoIcon,
  InseminatorIcon,
  LogoIcon,
  MegaMenuIcon,
  MilkingIcon,
  MonitoredAnimalIcon,
  NaturalMatingIcon,
  NotesIcon,
  NotificationIcon,
  NutritionIcon,
  PartiallyDisconnectedIcon,
  PerfilIcon,
  PlotlineArrivalIcon,
  PlotlineDietIcon,
  PlotlineDiscardIcon,
  PlotlineHandlingIcon,
  PlotlineHealthIcon,
  PlotlineReproductionIcon,
  PlotlineRuminationDecreaseIcon,
  PlotlineRuminationIncreaseIcon,
  PpiIcon,
  PregnancyDiagnosticIcon,
  PrimaryCComOfflineIcon,
  PrimaryCComWaitingIcon,
  PrintIcon,
  ReactionAngryIcon,
  ReactionExcitedIcon,
  ReactionNeutralIcon,
  ReactionSatisfiedIcon,
  ReactionWorriedIcon,
  RearingIcon,
  RefreshIcon,
  ReplaceIcon,
  ReproductionIcon,
  ReproductionProtocolIcon,
  RightIcon,
  RuleIcon,
  SearchIcon,
  SeedIcon,
  SentimentDissatisfiedIcon,
  SentimentNeutralIcon,
  SentimentSatisfiedIcon,
  SortAscIcon,
  SortDescIcon,
  SuccessIcon,
  SupportColoredIcon,
  SupportIcon,
  TechnicalVisitIcon,
  TemperatureColoredIcon,
  THIColoredIcon,
  TipIcon,
  VideoConferencingIcon,
  VisualHeatIcon,
  WaitingIcon,
  WarningIcon,
  WeaningIcon,
  WeighingIcon,
  WellnessIcon,
  WhatsappIcon,
} from './Collection'

// prettier-ignore
const pageBuilderIconMap = {
  'abortion':                          <AbortionIcon                   />,
  'account':                           <AccountIcon                    />,
  'activity':                          <Activity                       />,
  'animal':                            <AnimalIcon                     />,
  'apple':                             <Apple                          />,
  'asterisk':                          <AsteriskIcon                   />,
  'attach':                            <AttachIcon                     />,
  'attention':                         <AttentionIcon                  />,
  'ban':                               <Ban                            />,
  'batch':                             <BatchIcon                      />,
  'battery-colored':                   <BatteryColoredIcon             />,
  'battery-full':                      <BatteryFull                    />,
  'beef':                              <Beef                           />,
  'birth':                             <BirthIcon                      />,
  'book-text':                         <BookText                       />,
  'bull':                              <BullIcon                       />,
  'c-com-primary':                     <CComPrimaryIcon                />,
  'c-com-secondary':                   <CComSecondaryIcon              />,
  'c-tech':                            <CTechIcon                      />,
  'calendar-colored':                  <CalendarColoredIcon            />,
  'call':                              <CallIcon                       />,
  'camera':                            <Camera                         />,
  'can-sort':                          <CanSortIcon                    />,
  'check':                             <Check                          />,
  'check-icon':                        <CheckIcon                      />,
  'circle-off':                        <CircleOff                      />,
  'clock':                             <Clock                          />,
  'clock-alert':                       <ClockAlert                     />,
  'cloud-check':                       <CloudCheck                     />,
  'comfort':                           <ComfortIcon                    fontSize={24} />,
  'concentrate':                       <ConcentrateIcon                />,
  'conception':                        <ConceptionIcon                 />,
  'connected':                         <ConnectedIcon                  />,
  'corn':                              <CornIcon                       />,
  'cow-baby':                          <CowBabyIcon                    />,
  'cow-comfort':                       <CowComfortIcon                 fontSize={24} />,
  'cow-comfort-colored':               <CowComfortColoredIcon          />,
  'cs':                                <CSIcon                         />,
  'ctech':                             <CTechIcon                      />,
  'customer-service-colored':          <CustomerServiceColoredIcon     />,
  'data-analytics':                    <DataAnalyticsIcon              />,
  'dessert':                           <DessertIcon                    fontSize={24} />,
  'deteriorate':                       <TrendingDown                   />,
  'diagnostic':                        <SquareActivity                 />,
  'diet':                              <DietIcon                       />,
  'discard':                           <DiscardIcon                    />,
  'disconnected':                      <DisconnectedIcon               />,
  'double-check':                      <DoubleCheckIcon                />,
  'draw':                              <DrawIcon                       />,
  'droplets':                          <Droplets                       />,
  'drying':                            <DryingIcon                     />,
  'dtr':                               <DtrIcon                        />,
  'ellipsis-vertical':                 <EllipsisVertical               />,
  'email':                             <EmailIcon                      />,
  'embryo-donor':                      <EmbryoDonorIcon                />,
  'embryo-transfer':                   <EmbryoTransferIcon             />,
  'error':                             <ErrorIcon                      />,
  'exclamation-board':                 <ExclamationBoardIcon           />,
  'export':                            <ExportIcon                     />,
  'farm':                              <FarmIcon                       />,
  'farm-database':                     <FarmDatabaseIcon               />,
  'favorited':                         <Star                           fill='gold' color='gold' />,
  'file-text':                         <FileText                       />,
  'finance':                           <FinanceIcon                    />,
  'finance-colored':                   <FinanceColoredIcon             />,
  'gestational':                       <GestationalIcon                />,
  'handling':                          <HandlingIcon                   />,
  'hardware':                          <HardwareIcon                   />,
  'health':                            <HealthIcon                     fontSize={24} />,
  'health-protocol':                   <HealthProtocolIcon             />,
  'heart-pulse':                       <HeartPulseIcon                 />,
  'heat-strength':                     <HeatStrengthIcon               />,
  'help':                              <HelpIcon                       />,
  'herd':                              <AnimalIcon                     fontSize={24} />,
  'history':                           <History                        />,
  'home':                              <HomeIcon                       />,
  'humidity-colored':                  <HumidityColoredIcon            />,
  'import':                            <ImportIcon                     />,
  'improve':                           <TrendingUp                     />,
  'inapt':                             <InaptIcon                      />,
  'indicators':                        <IndicatorsIcon                 fontSize={24} />,
  'induced-lactation':                 <InducedLactationIcon           />,
  'info':                              <InfoIcon                       />,
  'inseminator':                       <InseminatorIcon                />,
  'layout-grid':                       <LayoutGrid                     />,
  'logo':                              <LogoIcon                       />,
  'map-pin':                           <MapPin                         />,
  'mega-menu':                         <MegaMenuIcon                   />,
  'milk':                              <Milk                           />,
  'milk-off':                          <MilkOff                        />,
  'milk-quality':                      <TestTubeDiagonalIcon           />,
  'monitored-animal':                  <MonitoredAnimalIcon            />,
  'natural-mating':                    <NaturalMatingIcon              />,
  'notes':                             <NotesIcon                      />,
  'notification':                      <NotificationIcon               />,
  'nutrition':                         <NutritionIcon                  />,
  'partially-disconnected':            <PartiallyDisconnectedIcon      />,
  'perfil':                            <PerfilIcon                     />,
  'pill':                              <Pill                           />,
  'pill-bottle':                       <PillBottle                     />,
  'plus':                              <PlusIcon                       />,
  'ppi':                               <PpiIcon                        />,
  'pregnancy-diagnostic':              <PregnancyDiagnosticIcon        />,
  'primary-c-com-offline':             <PrimaryCComOfflineIcon         />,
  'primary-c-com-waiting':             <PrimaryCComWaitingIcon         />,
  'print':                             <PrintIcon                      />,
  'production':                        <MilkingIcon                    fontSize={24} />,
  'reaction-angry':                    <ReactionAngryIcon              />,
  'reaction-excited':                  <ReactionExcitedIcon            />,
  'reaction-neutral':                  <ReactionNeutralIcon            />,
  'reaction-satisfied':                <ReactionSatisfiedIcon          />,
  'reaction-worried':                  <ReactionWorriedIcon            />,
  'rearing':                           <RearingIcon                    />,
  'refresh':                           <RefreshIcon                    />,
  'replace':                           <ReplaceIcon                    />,
  'reproduction':                      <ReproductionIcon               fontSize={24} />,
  'reproduction-protocol':             <ReproductionProtocolIcon       />,
  'right':                             <RightIcon                      />,
  'rows-3':                            <Rows3Icon                      />,
  'rule':                              <RuleIcon                       />,
  'search':                            <SearchIcon                     />,
  'seed':                              <SeedIcon                       />,
  'sentiment-dissatisfied':            <SentimentDissatisfiedIcon      />,
  'sentiment-neutral':                 <SentimentNeutralIcon           />,
  'sentiment-satisfied':               <SentimentSatisfiedIcon         />,
  'sort-asc':                          <SortAscIcon                    />,
  'sort-desc':                         <SortDescIcon                   />,
  'star':                              <StarIcon                       />,
  'success':                           <SuccessIcon                    />,
  'support':                           <SupportIcon                    />,
  'support-colored':                   <SupportColoredIcon             />,
  'technical-visit':                   <TechnicalVisitIcon             />,
  'temperature-colored':               <TemperatureColoredIcon         />,
  'thermometer':                       <Thermometer                    />,
  'thi-colored':                       <THIColoredIcon                 />,
  'tip':                               <TipIcon                        fontSize={24} />,
  'undo':                              <Undo2Icon                      />,
  'video-conferencing':                <VideoConferencingIcon          />,
  'visual-heat':                       <VisualHeatIcon                 />,
  'waiting':                           <WaitingIcon                    />,
  'warning':                           <WarningIcon                    />,
  'weaning':                           <WeaningIcon                    />,
  'weighing':                          <WeighingIcon                   />,
  'wellness':                          <WellnessIcon                   fontSize={24} />,
  'whatsapp':                          <WhatsappIcon                   />,
  'wheat':                             <Wheat                          />,
  'x':                                 <X                              />,
}

// prettier-ignore
const plotlineIconsMap = {
  'plotline-arrival':                  <PlotlineArrivalIcon            />,
  'plotline-diet':                     <PlotlineDietIcon               />,
  'plotline-discard':                  <PlotlineDiscardIcon            />,
  'plotline-handling':                 <PlotlineHandlingIcon           />,
  'plotline-health':                   <PlotlineHealthIcon             />,
  'plotline-reproduction':             <PlotlineReproductionIcon       />,
  'plotline-rumination-decrease':      <PlotlineRuminationDecreaseIcon />,
  'plotline-rumination-increase':      <PlotlineRuminationIncreaseIcon />,
}

// prettier-ignore
export const iconsMap = {
  'access-point-network':              <MdiIcon                        path={mdiAccessPointNetwork} />,
  'access-time':                       <AccessTime                     />,
  'account-box':                       <MdiIcon                        path={mdiAccountBox} />,
  'add':                               <Add                            />,
  'arrow-up-down':                     <ArrowUpDown                    />,
  'arrow-upward':                      <ArrowUpward                    />,
  'attach-file':                       <AttachFile                     />,
  'av-timer':                          <AvTimer                        />,
  'bell':                              <MdiIcon                        path={mdiBell} />,
  'bot-message-square':                <BotMessageSquare               />,
  'brain-circuit':                     <BrainCircuit                   />,
  'briefcase-medical':                 <BriefcaseMedical               />,
  'calendar':                          <Calendar                       />,
  'chart-spline':                      <ChartSpline                    />,
  'check-bold':                        <MdiIcon                        path={mdiCheckBold} />,
  'chevron-down':                      <ChevronDown                    />,
  'chevron-left':                      <ChevronLeft                    />,
  'chevron-right':                     <ChevronRight                   />,
  'chevron-up':                        <ChevronUp                      />,
  'circle-alert':                      <CircleAlert                    />,
  'circle-question-mark':              <CircleQuestionMark             />,
  'close':                             <MdiIcon                        path={mdiClose} />,
  'close-circle-outline':              <MdiIcon                        path={mdiCloseCircleOutline} />,
  'close-thick':                       <MdiIcon                        path={mdiCloseThick} />,
  'cloud-sync':                        <MdiIcon                        path={mdiCloudSync} />,
  'cloud-upload':                      <CloudUpload                    />,
  'colorize':                          <Colorize                       />,
  'content-copy':                      <MdiIcon                        path={mdiContentCopy} />,
  'copy':                              <Copy                           />,
  'create':                            <Create                         />,
  'create-outlined':                   <CreateOutlined                 />,
  'crop':                              <Crop                           />,
  'database':                          <Database                       />,
  'delete':                            <Delete                         />,
  'delete-forever-outlined':           <DeleteForeverOutlined          />,
  'done':                              <Done                           />,
  'download':                          <Download                       />,
  'drafts-outlined':                   <DraftsOutlined                 />,
  'edit':                              <Edit                           />,
  'exclamation-thick':                 <MdiIcon                        path={mdiExclamationThick} />,
  'eye-off':                           <EyeOff                         />,
  'face-agent':                        <MdiIcon                        path={mdiFaceAgent} />,
  'favorite-border':                   <FavoriteBorder                 />,
  'file-document':                     <MdiIcon                        path={mdiFileDocument} />,
  'file-down':                         <FileDown                       />,
  'file-download':                     <MdiIcon                        path={mdiFileDownload} />,
  'gift':                              <MdiIcon                        path={mdiGift} />,
  'grip-vertical':                     <GripVertical                   />,
  'hammer-wrench':                     <MdiIcon                        path={mdiHammerWrench} />,
  'hash':                              <Hash                           />,
  'heat-monitoring':                   <HeatMonitoringIcon             />,
  'help-outline':                      <HelpOutlined                   />,
  'info-outlined':                     <InfoOutlined                   />,
  'insert-drive-file-outlined':        <InsertDriveFileOutlined        />,
  'key-round':                         <KeyRound                       />,
  'keyboard-arrow-down':               <KeyboardArrowDown              />,
  'label':                             <Label                          />,
  'label-outlined':                    <LabelOutlined                  />,
  'language':                          <Language                       />,
  'lightbulb':                         <Lightbulb                      />,
  'link':                              <Link                           />,
  'link-2':                            <Link2                          />,
  'link-2-off':                        <Link2Off                       />,
  'list':                              <List                           />,
  'lucide-info':                       <Info                           />,
  'lucide-replace':                    <Replace                        />,
  'map':                               <Map                            />,
  'map-pinned':                        <MapPinned                      />,
  'maximize':                          <Maximize2                      />,
  'mdi-check':                         <MdiIcon                        path={mdiCheck} />,
  'mdi-chevron-down':                  <MdiIcon                        path={mdiChevronDown} />,
  'mdi-chevron-up':                    <MdiIcon                        path={mdiChevronUp} />,
  'mdi-download':                      <MdiIcon                        path={mdiDownload} />,
  'mdi-refresh':                       <MdiIcon                        path={mdiRefresh} />,
  'memory':                            <Memory                         />,
  'menu':                              <Menu                           />,
  'mic':                               <Mic                            />,
  'minimize':                          <Minimize2                       />,
  'minus':                             <MdiIcon                        path={mdiMinus} />,
  'more-vert':                         <MoreVert                       />,
  'mui-check':                         <MuiCheck                       />,
  'mui-chevron-left':                  <MuiChevronLeft                 />,
  'mui-chevron-right':                 <MuiChevronRight                />,
  'mui-close':                         <Close                          />,
  'mui-history':                       <MuiHistory                     />,
  'mui-info':                          <MuiInfo                        />,
  'mui-star':                          <MuiStar                        />,
  'north':                             <North                          />,
  'opacity':                           <Opacity                        />,
  'panel-left-close':                  <PanelLeftClose                 />,
  'panel-left-open':                   <PanelLeftOpen                  />,
  'pause':                             <Pause                          />,
  'pencil-line':                       <PencilLine                     />,
  'play':                              <Play                           />,
  'portable-wifi-off':                 <PortableWifiOff                />,
  'priority-high':                     <PriorityHigh                   />,
  'priority-high-rounded':             <PriorityHighRounded            />,
  'refresh-ccw':                       <RefreshCcw                     />,
  'room-outlined':                     <RoomOutlined                   />,
  'router':                            <Router                         />,
  'router-wireless':                   <MdiIcon                        path={mdiRouterWireless} />,
  'seal':                              <MdiIcon                        path={mdiSeal} />,
  'send':                              <Send                           />,
  'settings':                          <Settings                       />,
  'shield-user':                       <ShieldUser                     />,
  'signal-wifi-2-bar':                 <SignalWifi2Bar                 />,
  'south':                             <South                          />,
  'square':                            <Square                         />,
  'square-pen':                        <SquarePen                      />,
  'star-border':                       <StarBorder                     />,
  'tag':                               <Tag                            />,
  'thermometer-lines':                 <MdiIcon                        path={mdiThermometerLines} />,
  'timer-sand':                        <MdiIcon                        path={mdiTimerSand} />,
  'tractor':                           <Tractor                        />,
  'trash':                             <Trash2                         />,
  'triangle-alert':                    <TriangleAlert                  />,
  'user-lock':                         <UserLock                       />,
  'visibility-off-outlined':           <VisibilityOffOutlined          />,
  'visibility-outlined':               <VisibilityOutlined             />,
  'weather-windy':                     <MdiIcon                        path={mdiWeatherWindy} />,
  'wifi':                              <MdiIcon                        path={mdiWifi} />,
  'wifi-sync':                         <MdiIcon                        path={mdiWifiSync} />,
  'wifi-tethering':                    <WifiTethering                  />,
  ...pageBuilderIconMap,
  ...plotlineIconsMap,
}

export type IconType = keyof typeof iconsMap
